import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropzoneIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 84,
	height: 83,
	viewBox: "0 0 84 83",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.9353 71.4356C63.9961 71.4356 63.2277 70.6715 63.2277 69.7378V62.2411C63.2277 61.3073 63.9961 60.5432 64.9353 60.5432H72.3852C73.3244 60.5432 74.0929 61.3073 74.0929 62.2411V69.7378C74.0929 70.6715 73.3244 71.4356 72.3852 71.4356H64.9353Z",
			fill: "#F4F8FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.1089 10.71H34.4429C32.0381 10.71 30.0886 12.6595 30.0886 15.0643V48.8365C30.0886 51.2413 32.0381 53.1907 34.4429 53.1907H68.1089C70.5137 53.1907 72.4631 51.2413 72.4631 48.8365V15.0643C72.4631 12.6595 70.5137 10.71 68.1089 10.71Z",
			fill: "#9D9D9D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.0445 25.5735C40.8443 25.5735 40.6823 25.318 40.6823 25.0023V22.7177C40.6823 22.4026 40.8443 22.1471 41.0445 22.1471H51.1853C51.3855 22.1471 51.5475 22.4026 51.5475 22.7177V25.0023C51.5475 25.318 51.3855 25.5735 51.1853 25.5735H41.0445Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M66.9399 33.7428H41.5878C41.0873 33.7428 40.6823 33.4874 40.6823 33.1717V30.8871C40.6823 30.5719 41.0873 30.3165 41.5878 30.3165H66.9399C67.4404 30.3165 67.8454 30.5719 67.8454 30.8871V33.1717C67.8454 33.4874 67.4404 33.7428 66.9399 33.7428Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.4067 41.9122C41.0063 41.9122 40.6823 41.6567 40.6823 41.3411V39.0565C40.6823 38.7413 41.0063 38.4858 41.4067 38.4858H61.6884C62.0887 38.4858 62.4128 38.7413 62.4128 39.0565V41.3411C62.4128 41.6567 62.0887 41.9122 61.6884 41.9122H41.4067Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.9096 30.0442H16.2435C13.8387 30.0442 11.8893 31.9937 11.8893 34.3984V68.1707C11.8893 70.5755 13.8387 72.5249 16.2435 72.5249H49.9096C52.3144 72.5249 54.2638 70.5755 54.2638 68.1707V34.3984C54.2638 31.9937 52.3144 30.0442 49.9096 30.0442Z",
			fill: "#DEDEDE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2435 30.0442H49.9096C52.3144 30.0442 54.2638 31.9937 54.2638 34.3984V40.0524H11.8893V34.3984C11.8893 31.9937 13.8387 30.0442 16.2435 30.0442Z",
			fill: "#E1373B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.35 53.04C39.67 49.59 36.64 47 33 47C30.11 47 27.6 48.64 26.35 51.04C23.34 51.36 21 53.91 21 57C21 60.31 23.69 63 27 63H40C42.76 63 45 60.76 45 58C45 55.36 42.95 53.22 40.35 53.04ZM35 56V60H31V56H28L33 51L38 56H35Z",
			fill: "url(#paint0_linear_645_15051)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M67.7603 61.616V62.3714L61.3397 62.3714V61.616H59.4933V63.4625H61.3397V62.7071L66.6635 62.7071C63.8211 63.5452 61.6988 66.0659 61.4455 69.1181C61.005 69.1881 60.6683 69.5697 60.6683 70.0299C60.6683 70.5398 61.0816 70.9532 61.5915 70.9532C62.1014 70.9532 62.5147 70.5398 62.5147 70.0299C62.5147 69.5852 62.2004 69.214 61.7817 69.1263C62.0608 65.8745 64.564 63.259 67.7603 62.8128V63.4625H69.6067V62.7999C72.85 63.2059 75.402 65.8421 75.6832 69.1278C75.268 69.2181 74.9571 69.5877 74.9571 70.0299C74.9571 70.5398 75.3705 70.9532 75.8803 70.9532C76.3902 70.9532 76.8036 70.5398 76.8036 70.0299C76.8036 69.5672 76.4632 69.184 76.0192 69.117C75.7655 66.0653 73.6434 63.5451 70.8014 62.7071L76.1061 62.7071V63.4625H77.9526V61.616H76.1061V62.3714L69.6067 62.3714V61.616H67.7603ZM68.096 61.9517H69.271V63.1267H68.096V61.9517ZM59.829 63.1268V61.9517H61.004V63.1268H59.829ZM76.4418 61.9517H77.6168V63.1268H76.4418V61.9517ZM61.004 70.0299C61.004 69.7054 61.267 69.4424 61.5915 69.4424C61.5943 69.4424 61.5972 69.4424 61.6 69.4424C61.9205 69.447 62.179 69.7083 62.179 70.0299C62.179 70.3544 61.916 70.6175 61.5915 70.6175C61.267 70.6175 61.004 70.3544 61.004 70.0299ZM75.8663 69.4425C75.8687 69.4425 75.8711 69.4424 75.8735 69.4424C75.875 69.4424 75.8765 69.4424 75.878 69.4424L75.8803 69.4424C76.2048 69.4424 76.4678 69.7054 76.4678 70.0299C76.4678 70.3544 76.2048 70.6175 75.8803 70.6175C75.5559 70.6175 75.2928 70.3544 75.2928 70.0299C75.2928 69.7101 75.5484 69.4499 75.8663 69.4425Z",
			fill: "url(#paint1_linear_645_15051)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.4639 75.6496L68.7429 66.2076L64.0219 75.6496H73.4639Z",
			fill: "url(#paint2_linear_645_15051)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .3,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M4.68467 9.14129C5.41496 9.87158 6.59903 9.87156 7.32935 9.14124C8.05967 8.41092 8.05969 7.22685 7.3294 6.49656C6.5991 5.76626 5.41504 5.76629 4.68472 6.49661C3.9544 7.22693 3.95437 8.41099 4.68467 9.14129Z",
					fill: "#656565"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.4173 25.1268C21.1476 25.8571 22.3316 25.8571 23.0619 25.1268C23.7922 24.3965 23.7922 23.2124 23.0619 22.4821C22.3316 21.7518 21.1476 21.7518 20.4173 22.4821C19.687 23.2124 19.687 24.3965 20.4173 25.1268Z",
					fill: "#656565"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.95832 13.159C11.8429 11.2744 14.8985 11.2744 16.7831 13.159C18.6677 15.0436 18.6677 18.0992 16.7831 19.9838C14.8984 21.8684 11.8429 21.8684 9.95827 19.9838C8.07367 18.0992 8.07369 15.0437 9.95832 13.159Z",
					fill: "#656565"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.6639 14.2796C27.6639 15.3124 26.8267 16.1496 25.7939 16.1496C24.7611 16.1496 23.9238 15.3124 23.9238 14.2796C23.9238 13.2468 24.7611 12.4096 25.7939 12.4096C26.8267 12.4096 27.6639 13.2468 27.6639 14.2796Z",
					fill: "#656565"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_645_15051",
				x1: 33,
				y1: 47,
				x2: 33,
				y2: 63,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#606060" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#373737"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_645_15051",
				x1: 68.7229,
				y1: 61.616,
				x2: 68.7229,
				y2: 75.6496,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF494E" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E21E23"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_645_15051",
				x1: 68.7229,
				y1: 61.616,
				x2: 68.7229,
				y2: 75.6496,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF494E" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E21E23"
				})]
			})
		] })
	]
});
export default SvgDropzoneIcon;
